import React, { useState, useEffect, useRef, setLoading, setError } from 'react';
import axios from 'axios';

const API_BASE_URL = 'http://localhost:8000'; // Or your deployed backend URL

const api = axios.create({
    baseURL: API_BASE_URL,
});

// Add token to requests
// api.interceptors.request.use((config) => {
//     const token = localStorage.getItem('token');
//     if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
// });

// export const authAPI = {
//     login: (email, password) => {
//         const formData = new FormData();
//         formData.append('username', email);
//         formData.append('password', password);
//         return api.post('/api/auth/login', formData);
//     },
    
//     register: (userData) => api.post('/api/auth/register', userData),
    
//     verifyEmail: (token) => api.get(`/api/auth/verify-email?token=${token}`),
// };

export const tickerAPI = async (ticker) => {

  // getGeneralDetails: (ticker) => api.get(`/api/metrics/ticker=${ticker}`)

  //getMetrics: (ticker) => api.get(`/api/metrics/technical-analysis/`, requestInput),

  //getPredictions: (ticker) => api.get(`/api/metrics/predict`, requestInput),
};

export const fetchStockMetrics = async (ticker) => {
  try {
    const response = await fetch(`${API_BASE_URL}/metrics?ticker=${ticker}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching stock metrics:", error);
    throw error;
  }
};

export const fetchStockIndicators = async (
  ticker = 'AAPL',
  period = '1mo'
) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/techIndicators/indicators?ticker=${ticker}&period=${period}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching stock metrics:", error);
    throw error;
  }
};

export const fetchStockChartPatterns = async (
  ticker = 'AAPL',
  period = '1mo'
) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/chartPatterns/patterns?ticker=${ticker}&period=${period}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching stock metrics:", error);
    throw error;
  }
};

export const runBacktest = async (ohlcData) => {
  //<div>{JSON.stringify(ohlcData)}</div>

  const requestData = {
    ohlc_data: ohlcData,  // snake_case
    fast_period: 12,       // number (not string)
    slow_period: 26,
    signal_period: 9,
    initial_balance: 10000, // number (not string)
    commission: 0.0,       // number (not string)
  };

    try {
    const response = await axios.post('http://localhost:8000/backtest',
     requestData,
     {
       headers: {
         'Content-Type': 'application/json',
       },
     }
   );
   return response.data;
  } catch (err) {
    console.error('Full error:', err.response); // Log detailed error
//    setError(err.response?.data?.detail || err.message);
  }
};
//   const response = await axios.post(
//     'http://localhost:8000/backtest',
//     requestData,
//     {
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     }
//   );
//   return response.data;
// };


// export const runBacktest = async (ohlcData, parameters) => {
//   try {
//     const response = await axios.post(`${API_URL}/backtest`, {
//       ohlc_data: ohlcData,
//       fast_period: parameters.fastPeriod,
//       slow_period: parameters.slowPeriod,
//       signal_period: parameters.signalPeriod,
//       initial_balance: parameters.initialBalance
//     });
//     return response.data;
//   } catch (error) {
//     console.error('Backtest error:', error);
//     throw error;
//   }
// };

export default {api, fetchStockMetrics, runBacktest};